import React from 'react';
import { GamePhase, GameStatus } from '../types';
import { formatPhaseLadderWarning, PhaseLadderShortage } from '../utils/phaseLadderValidation';
import './LevelsPanel.css';

interface LevelsPanelProps {
  gamePhases: GamePhase[];
  status: GameStatus;
  onRenamePhase: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onIncreasePhaseDifficulty: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onReducePhaseDifficulty: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onIncreasePhases: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onReducePhases: (e: React.MouseEvent<HTMLButtonElement>) => void;
  phaseLadderShortages?: PhaseLadderShortage[];
}

const LevelsPanelComponent: React.FC<LevelsPanelProps> = ({
  gamePhases,
  status,
  onRenamePhase,
  onIncreasePhaseDifficulty,
  onReducePhaseDifficulty,
  onIncreasePhases,
  onReducePhases,
  phaseLadderShortages = [],
}) => {
  const actualPhase = status.phase;
  const shortDifficulties = new Set(phaseLadderShortages.map((shortage) => shortage.difficulty));

  return (
    <div className="levels-panel">
      <div className="text-center mb-4">
        <h2 className="text-white font-bold" style={{ letterSpacing: '2px' }}>
          LA <span style={{ color: 'var(--betis-green)' }}>VIDA</span> EN VERDE
        </h2>
      </div>
      {phaseLadderShortages.length > 0 && (
        <div className="phase-ladder-warning" role="alert">
          {phaseLadderShortages.map((shortage) => (
            <p key={shortage.difficulty}>⚠ {formatPhaseLadderWarning(shortage)}</p>
          ))}
        </div>
      )}
      <div className="fase-container">
        <div
          id="rewards-container"
          className="d-flex flex-column-reverse"
        >
          <div className="d-flex justify-content-evenly w-100 mb-2">
            <button
              className={"rounded-circle" + (actualPhase !== -1 ? ' hidden' : '')}
              onClick={onIncreasePhases}
              aria-label="Aumentar número de fases">
              +
            </button>
            <button
              className={"rounded-circle" + (actualPhase !== -1 ? ' hidden' : '')}
              onClick={onReducePhases}
              aria-label="Reducir número de fases">
              -
            </button>
          </div>
          {gamePhases.map((phase, i) => {
            const isResolved = i < status.phase;
            const isActive = i === status.phase;

            let itemClasses = `reward-item difficulty-${phase.difficulty}`;
            if (isActive) itemClasses += ' active';
            if (isResolved) itemClasses += ' resolved';
            if (shortDifficulties.has(phase.difficulty as 0 | 1 | 2)) itemClasses += ' phase-shortage';

            return (
              <div key={i} className={itemClasses}>
                <button
                  id={`reduce-${i}`}
                  className={"rounded-circle" + (actualPhase !== -1 ? ' hidden' : '')}
                  onClick={onReducePhaseDifficulty}
                  aria-label={`Reducir dificultad de la fase ${i + 1}`}
                >
                  {"<"}
                </button>
                <input
                  id={`phase-${i}`}
                  disabled={actualPhase !== -1}
                  type="text"
                  className={`difficulty-${phase.difficulty}`}
                  defaultValue={phase.name}
                  placeholder={`Pregunta ${i + 1}`}
                  onChange={onRenamePhase}
                  aria-label={`Nombre de la fase ${i + 1}`}
                />
                <button
                  id={`increase-${i}`}
                  className={"rounded-circle" + (actualPhase !== -1 ? ' hidden' : '')}
                  onClick={onIncreasePhaseDifficulty}
                  aria-label={`Aumentar dificultad de la fase ${i + 1}`}
                >
                  {">"}
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export const LevelsPanel = React.memo(LevelsPanelComponent);
